const EdaStatusType = {
	PENDING: 'Pending',
	UNDER_PROCESSING: 'Under Processing',
	DONE: 'Done',
	FAILED: 'Failed'
};

export default EdaStatusType;
